import { reactive } from 'vue';

export const supplierFlagStore = reactive({
    id: 0,
    website: '',
    matches: '',
    terms: ''
});